if (!customElements.get('gwp-button')) {
  class GWPButton extends HTMLElement {
    constructor() {
      super();
      this.popup = document.querySelector(this.getAttribute('data-target'));
      this.handleDocumentKeyup = this.handleDocumentKeyup.bind(this);
      this.handlePopupClick = this.handlePopupClick.bind(this);
      this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleButtonClick);
      if (this.popup) {
        this.popup.addEventListener('click', this.handlePopupClick);
        document.addEventListener('keyup', this.handleDocumentKeyup);
        
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleButtonClick);
      if (this.popup) {
        this.popup.removeEventListener('click', this.handlePopupClick);
        this.popup.removeEventListener('touchend', this.handlePopupClick);
      }
      document.removeEventListener('keyup', this.handleDocumentKeyup);
    }

    handleButtonClick() {
      this.togglePopup();
    }

    handlePopupClick(event) {      
      if (event.target === event.currentTarget || event.target.classList.contains('gwp-popup__close')) {
        this.togglePopup();
      }
    }

    handleDocumentKeyup(event) {
      const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
      if (charCode === 'ESCAPE') this.togglePopup();
    }

    togglePopup() {
      this.popup && this.popup.classList.toggle('open');
    }
  }

  customElements.define("gwp-button", GWPButton);
}
